<span class="info-tooltip">
  <button
    type="button"
    class="info-tooltip__icon"
    (click)="toggle($event)"
    [attr.aria-expanded]="open"
    aria-label="Informazioni"
  >i</button>
  <div
    #popover
    class="info-tooltip__popover"
    [class.info-tooltip__popover--left]="position === 'left'"
    [style.transform]="shiftX ? 'translateX(' + shiftX + 'px)' : null"
    *ngIf="open"
  >{{ text }}</div>
</span>
